var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0001 2C15.3432 2 14.0001 3.34315 14.0001 5V16C14.0001 17.6569 15.3432 19 17.0001 19H26.0001V21H17.0001C14.2387 21 12.0001 18.7614 12.0001 16V5C12.0001 2.23858 14.2387 0 17.0001 0H26.0001V2H17.0001Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5001 7C23.5671 7 22.0001 8.567 22.0001 10.5C22.0001 12.433 23.5671 14 25.5001 14V16C22.4625 16 20.0001 13.5376 20.0001 10.5C20.0001 7.46243 22.4625 5 25.5001 5V7Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0001 19C17.0001 17.3431 15.6569 16 14.0001 16V14C16.7615 14 19.0001 16.2386 19.0001 19H17.0001Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0001 2C17.0001 3.65685 15.6569 5 14.0001 5V7C16.7615 7 19.0001 4.76142 19.0001 2H17.0001Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33126 17.8119C10.1921 17.8119 11.7006 16.3034 11.7006 14.4426C11.7006 12.5818 10.1921 11.0732 8.33126 11.0732C6.47042 11.0732 4.96191 12.5818 4.96191 14.4426C4.96191 16.3034 6.47042 17.8119 8.33126 17.8119ZM8.33126 19.8119C11.2967 19.8119 13.7006 17.408 13.7006 14.4426C13.7006 11.4772 11.2967 9.07324 8.33126 9.07324C5.36585 9.07324 2.96191 11.4772 2.96191 14.4426C2.96191 17.408 5.36585 19.8119 8.33126 19.8119Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7387 10.3693C10.7387 13.3348 8.33476 15.7387 5.36935 15.7387C2.40394 15.7387 0 13.3348 0 10.3693C0 7.40394 2.40394 5 5.36935 5C8.33476 5 10.7387 7.40394 10.7387 10.3693Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.36935 13.7387C7.23019 13.7387 8.7387 12.2302 8.7387 10.3693C8.7387 8.50851 7.23019 7 5.36935 7C3.50851 7 2 8.50851 2 10.3693C2 12.2302 3.50851 13.7387 5.36935 13.7387ZM5.36935 15.7387C8.33476 15.7387 10.7387 13.3348 10.7387 10.3693C10.7387 7.40394 8.33476 5 5.36935 5C2.40394 5 0 7.40394 0 10.3693C0 13.3348 2.40394 15.7387 5.36935 15.7387Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMoney);
export default __webpack_public_path__ + "static/media/ico_money.cff396bd244bd3330feee54bd10cf269.svg";
export { ForwardRef as ReactComponent };